export const showOverlayConstants = {
  SHOW_OVERLAY: 'SHOW_OVERLAY',
  CLOSE_OVERLAY: 'CLOSE_OVERLAY',
  CLOSE_ALL_OVERLAY: 'CLOSE_ALL_OVERLAY',
};
